import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'
import Tooltip from 'scoreboard/components/tooltip'
import momentHelper from 'scoreboard/components/moment-helper'


/**
 * For creating a tooltip to show a formatted date #50109
 * For example, when hovering over "2 days ago", the tooltip would display
 * "Nov 14, 2022 12:35:50 PM"
 *
 * Set up your HTML like this, and the data-date attribute will determine the
 * text of the tooltip:
 *
 * <span class="date-tooltip" data-date="{{created}}">
 * </span>
 *
 * Set up your JavaScript like this:
 *
 * render: function() {
 *     // all your render logic
 *     this.dateTooltips = new DateTooltips({ el: this.el })
 * },
 *
 * remove: function() {
 *     Backbone.View.prototype.remove.apply(this, arguments)
 *     _.invokeMap([this.dateTooltips], 'remove')
 * }
 */
const DateTooltips = Backbone.View.extend({

	events: {
		'mouseenter .date-tooltip': 'tooltip',
		'mouseleave .date-tooltip': 'removeTooltip'
	},

	tooltip: function(e) {
		let target = $(e.currentTarget)
		let date = target.data('date')


		if (!date) {
			return
		}

		let tooltipContent = momentHelper.formatDateTime(date)

		if (this._tooltip) {
			this._tooltip.remove()
		}

		this._tooltip = new Tooltip({
			attachTo: target,
			content: tooltipContent,
			placement: 'above',
			arrow: 'center'
		}).render()
	},

	removeTooltip: function() {
		this._tooltip && this._tooltip.remove()
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this._tooltip], 'remove')
	},

	cleanup: function() {
		this.undelegateEvents()
		_.invokeMap([this._tooltip], 'remove')
	}

})

export default DateTooltips

DateTooltips.__filename__ = 'components/date-tooltips.js'
